import { render, staticRenderFns } from "./account_record.vue?vue&type=template&id=ff83e88c&scoped=true"
import script from "./account_record.vue?vue&type=script&lang=js"
export * from "./account_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff83e88c",
  null
  
)

export default component.exports